import React, { PureComponent } from 'react';
import { withRouter } from 'inferno-router';
import {
  Image,
  StyleSheet,
  Text,
  TouchableHighlight,
  View,
} from '../base_components';

import EventStore from '../../stores/event_store';

const styles = StyleSheet.create({
  eventBanner: {
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  buttonWrapper: {
    height: '7.2em',
    width: '24em',
    marginBottom: '2em',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  highlight: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  inner: {
    flex: 1,
    alignSelf: 'stretch',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    marginLeft: '2em',
    marginRight: '2em',
    alignSelf: 'stretch',
    color: 'white',
    fontSize: '1.2em',
    textAlign: 'center',
  },
});

type Props = {
  style: any;
};
type State = {
  show_abridged1: boolean;
};

const PROMO_BUTTON = require('../../assets/img/promo_button.png');

export class EventBanner extends PureComponent<Props, State> {
  state = {
    show_abridged1: false,
  };
  componentDidMount() {
    EventStore.addChangeListener(this._onEventChange);
    this._onEventChange();
  }
  componentWillUnmount() {
    EventStore.removeChangeListener(this._onEventChange);
  }
  _onEventChange = () => {
    if (EventStore.isActive('event_ad_abridged1')) {
      this.setState({ show_abridged1: true });
    }
  };

  _onPress = () => {
    this.props.history.push('/abridged');
  };

  render() {
    const { style } = this.props;
    const { show_abridged1 } = this.state;
    let content = null;
    if (show_abridged1) {
      content = (
        <View style={[styles.eventBanner, style]}>
          <View style={styles.buttonWrapper}>
            <Image style={styles.buttonImage} source={PROMO_BUTTON} />
            <TouchableHighlight
              style={styles.highlight}
              onPress={this._onPress}
            >
              <View style={styles.inner}>
                <Text style={styles.text}>Abridged Dank Coin Giveaway!</Text>
              </View>
            </TouchableHighlight>
          </View>
          <iframe
            title='youtube'
            src='https://www.youtube.com/embed/3SvXYLR1tQw'
            frameborder='0'
            allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
            allowfullscreen
          ></iframe>
        </View>
      );
    }
    return content;
  }
}
export default withRouter(EventBanner);
